<div class="license-lock-backdrop" [class.license-lock-backdrop--contained]="contained" role="presentation">
  <div class="license-lock-content" role="dialog" aria-modal="true">
    <div class="license-lock-scroll">
      <div class="lock-icon">
        <i class="material-symbols-rounded filled">lock</i>
      </div>
      <div>
        <h2 class="title mb-2">{{ title }}</h2>
        <p class="text" [innerHTML]="text"></p>
        <ng-container *ngIf="moduleKey === 'shared/managementApp'">
          <p class="license-lock-checklist-title">{{ 'management/lock/management/description' | transloco }}</p>
          <ul class="license-lock-checklist">
            <li class="license-lock-checklist-item">
              <i class="material-symbols-rounded filled">check</i>
              <span>{{ 'management/lock/management/features/sendPhotosAndDocuments' | transloco }}</span>
            </li>
            <li class="license-lock-checklist-item">
              <i class="material-symbols-rounded filled">check</i>
              <span>{{ 'management/lock/management/features/msmtDataExport' | transloco }}</span>
            </li>
            <li class="license-lock-checklist-item">
              <i class="material-symbols-rounded filled">check</i>
              <span>{{ 'management/lock/management/features/electronicClassBook' | transloco }}</span>
            </li>
            <li class="license-lock-checklist-item">
              <i class="material-symbols-rounded filled">check</i>
              <span>{{ 'management/lock/management/features/attendanceEntry' | transloco }}</span>
            </li>
            <li class="license-lock-checklist-item">
              <i class="material-symbols-rounded filled">check</i>
              <span>{{ 'management/lock/management/features/attendanceOverviews' | transloco }}</span>
            </li>
            <li class="license-lock-checklist-item">
              <i class="material-symbols-rounded filled">check</i>
              <span>{{ 'management/lock/management/features/childrenGroupsAndClasses' | transloco }}</span>
            </li>
          </ul>
        </ng-container>
        <ng-container *ngIf="moduleKey === 'childrenPortfolio/title'">
          <p class="license-lock-checklist-title">{{ 'management/lock/childPortfolio/description' | transloco }}</p>
          <ul class="license-lock-checklist">
            <li class="license-lock-checklist-item">
              <i class="material-symbols-rounded filled">check</i>
              <span>{{ 'management/lock/childPortfolio/features/continuousMonitoring' | transloco }}</span>
            </li>
            <li class="license-lock-checklist-item">
              <i class="material-symbols-rounded filled">check</i>
              <span>{{ 'management/lock/childPortfolio/features/pedagogicalDiagnostics' | transloco }}</span>
            </li>
            <li class="license-lock-checklist-item">
              <i class="material-symbols-rounded filled">check</i>
              <span>{{ 'management/lock/childPortfolio/features/planning' | transloco }}</span>
            </li>
            <li class="license-lock-checklist-item">
              <i class="material-symbols-rounded filled">check</i>
              <span>{{ 'management/lock/childPortfolio/features/contextRecords' | transloco }}</span>
            </li>
            <li class="license-lock-checklist-item">
              <i class="material-symbols-rounded filled">check</i>
              <span>{{ 'management/lock/childPortfolio/features/printRecords' | transloco }}</span>
            </li>
          </ul>
          <p class="license-lock-checklist-title">{{ 'management/lock/childPortfolio/downloads/title' | transloco }}</p>
          <ul class="license-lock-checklist">
            <li class="license-lock-checklist-item">
              <i class="material-symbols-rounded filled">check</i>
              <span>{{ 'management/lock/childPortfolio/downloads/developmentObservationCards' | transloco }}</span>
            </li>
            <li class="license-lock-checklist-item">
              <i class="material-symbols-rounded filled">check</i>
              <span>{{ 'management/lock/childPortfolio/downloads/inspirationActivityCards' | transloco }}</span>
            </li>
            <li class="license-lock-checklist-item">
              <i class="material-symbols-rounded filled">check</i>
              <span>{{ 'management/lock/childPortfolio/downloads/portfolioInHand' | transloco }}</span>
            </li>
            <li class="license-lock-checklist-item">
              <i class="material-symbols-rounded filled">check</i>
              <span>{{ 'management/lock/childPortfolio/downloads/adaptationRecords' | transloco }}</span>
            </li>
            <li class="license-lock-checklist-item">
              <i class="material-symbols-rounded filled">check</i>
              <span>{{ 'management/lock/childPortfolio/downloads/activityIdeasPocketbook' | transloco }}</span>
            </li>
            <li class="license-lock-checklist-item">
              <i class="material-symbols-rounded filled">check</i>
              <span>{{ 'management/lock/childPortfolio/downloads/selfDevelopmentCards' | transloco }}</span>
            </li>
            <li class="license-lock-checklist-item">
              <i class="material-symbols-rounded filled">check</i>
              <span>{{ 'management/lock/childPortfolio/downloads/smarticky' | transloco }}</span>
            </li>
            <li class="license-lock-checklist-item">
              <i class="material-symbols-rounded filled">check</i>
              <span>{{ 'management/lock/childPortfolio/downloads/interestQuestionnaire' | transloco }}</span>
            </li>
          </ul>
        </ng-container>
        <ng-container *ngIf="moduleKey === 'shared/papApp'">
          <p class="license-lock-checklist-title">{{ 'management/lock/pap/description' | transloco }}</p>
          <ul class="license-lock-checklist">
            <li class="license-lock-checklist-item">
              <i class="material-symbols-rounded filled">check</i>
              <span>{{ 'management/lock/pap/features/professionalPortfolioRecords' | transloco }}</span>
            </li>
            <li class="license-lock-checklist-item">
              <i class="material-symbols-rounded filled">check</i>
              <span>{{ 'management/lock/pap/features/furtherEducationPlans' | transloco }}</span>
            </li>
            <li class="license-lock-checklist-item">
              <i class="material-symbols-rounded filled">check</i>
              <span>{{ 'management/lock/pap/features/selfEvaluationResults' | transloco }}</span>
            </li>
            <li class="license-lock-checklist-item">
              <i class="material-symbols-rounded filled">check</i>
              <span>{{ 'management/lock/pap/features/printableReports' | transloco }}</span>
            </li>
            <li class="license-lock-checklist-item">
              <i class="material-symbols-rounded filled">check</i>
              <span>{{ 'management/lock/pap/features/excelExports' | transloco }}</span>
            </li>
            <li class="license-lock-checklist-item">
              <i class="material-symbols-rounded filled">check</i>
              <span>{{ 'management/lock/pap/features/statistics' | transloco }}</span>
            </li>
          </ul>
        </ng-container>
      </div>
      <ng-container
        *ngIf="
          moduleKey === 'shared/managementApp' || moduleKey === 'childrenPortfolio/title' || moduleKey === 'shared/papApp';
          else defaultLockCta
        "
      >
        <div class="license-lock-cta-group">
          <a *ngIf="showPricingCta" class="btn btn-primary btn-lg w-100 license-lock-cta" [routerLink]="['/settings/price-list']">
            {{
              (moduleKey === 'childrenPortfolio/title'
                ? 'management/lock/childPortfolio/ctaPricing'
                : moduleKey === 'shared/papApp'
                ? 'management/lock/pap/ctaPricing'
                : 'management/lock/management/ctaPricing'
              ) | transloco
            }}
          </a>
          <a
            class="btn btn-outline-primary btn-lg w-100 license-lock-secondary-cta"
            href="https://isophi.cz/konzultace/"
            target="_blank"
            rel="noopener noreferrer"
          >
            {{
              (moduleKey === 'childrenPortfolio/title'
                ? 'management/lock/childPortfolio/ctaConsultation'
                : moduleKey === 'shared/papApp'
                ? 'management/lock/pap/ctaConsultation'
                : 'management/lock/management/ctaConsultation'
              ) | transloco
            }}
          </a>
        </div>
      </ng-container>
      <ng-template #defaultLockCta>
        <a *ngIf="showPricingCta" class="btn btn-primary btn-lg w-100 license-lock-cta" [routerLink]="['/settings/price-list']">
          {{ 'management/lock/cta' | transloco }}
        </a>
      </ng-template>
      <div class="license-lock-note">
        <i class="material-symbols-rounded filled">info</i>
        {{
          (moduleKey === 'shared/managementApp'
            ? 'management/lock/management/note'
            : moduleKey === 'childrenPortfolio/title'
            ? 'management/lock/childPortfolio/note'
            : moduleKey === 'shared/papApp'
            ? 'management/lock/pap/note'
            : 'management/lock/note'
          ) | transloco
        }}
      </div>
    </div>
  </div>
</div>
